import React, { useState, useEffect } from 'react'
import sbi from "../images/sbi.svg";
import Otp from './Otp';
import Footer from './Footer';
import { useMyContext } from '../../AppContext';
import { AccountDiscoveryHeader,AccountLinkingHeader,UserLinkedAccountHeader } from '../helper/HeaderMakerforSocket';
import { v4 as uuidv4 } from 'uuid';
import { toast} from 'react-toastify';
import { AccountDiscoveryApi} from '../Apiservices';
import { useNavigate } from 'react-router-dom';
import { HandleNotLinkedAccountNumbers,GetFipTypeForABank } from '../helper/Commonfunctions';
import { ImagesURL } from '../helper/Commonfunctions';
import { Loader } from '../helper/Loader';
import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function LinkAccount() {
    const [Pendingrequest,SetPendingRequest]=useState(false);
    const [data,Setdata]=useState([]);
    const [show,Setshow]=useState(false);
    const { Storage,SetStorage } = useMyContext();
    const navigate=useNavigate();
 
const [Bankinfo,SelectBankinfo]=useState([]);
const [CheckedData,SetCheckedData]=useState([]);
const [DiscoveredAccountDetail,SetDiscoveredAccountDetail]=useState();
const [AccountLinkResponse,SetAccountLinkResponse]=useState();
const [AccountLinkInfo,SetLinkedAccountInfo]=useState([]);
    useEffect(() => {

      const previousPage = document.referrer;
 
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, null, window.location.href);
      }
      

      if(Storage.Socketconnnection==null)
      {
   
          localStorage.clear();
          window.open(process.env.REACT_APP_CLOSING_URL, "_self");
      }
      else{
    HandleUserLinkedAccounts();
      
       mixpanel.track("Viewed_BS_Link_Account", {
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    }
// console.log("sdajb");
return () => {
  window.onpopstate = null;
};

    }, [])

    const GetStringLastvalues=(AccountNUmber)=>{

        let accn="";
        for(let i=0;i<5;i++)
        {
          accn+='X';
        }
        accn+=AccountNUmber[AccountNUmber.length-4];
        accn+=AccountNUmber[AccountNUmber.length-3];
        accn+=AccountNUmber[AccountNUmber.length-2];
        accn+=AccountNUmber[AccountNUmber.length-1];
        return accn;
      
      }
    const HandleUserLinkedAccounts=()=>{
        UserLinkedAccountHeader.sid=Storage?.sessionid;
        const message={
         header:UserLinkedAccountHeader,
         payload:{
             userId: Storage?.userid
         }
        };
        const Socketconnnection=Storage.Socketconnnection;
        if(!Socketconnnection)
        {
          localStorage.clear();
          window.open(process.env.REACT_APP_CLOSING_URL, "_self");
        }
        else{
        Socketconnnection.onclose=()=>{
            localStorage.removeItem('insession');
            toast.error("Your session is expired. Please try again");
         setTimeout(()=>{
          localStorage.clear();
          window.open(process.env.REACT_APP_CLOSING_URL, "_self");
         },1000)
        }
        Socketconnnection.send(JSON.stringify(message));
        SetPendingRequest(true);
        Socketconnnection.onmessage = (event) => {
         const receivedMessage = JSON.parse(event.data);
         const BankLinkedacoounts= receivedMessage?.payload?.LinkedAccounts?.filter(account => account?.fipId === Storage?.selectedbank?.fip_id)
         SetLinkedAccountInfo(BankLinkedacoounts);
        //  console.log(BankLinkedacoounts);/
         handleAccountDiscovery(BankLinkedacoounts);
         
       };
    }
 
     }
    const handleAccountDiscovery=(AllLinkedAccounts,nooftimeapicalled=0)=>{

       const Socketconnnection=Storage.Socketconnnection;
       if(!Socketconnnection)
       {
        localStorage.clear();
        window.open(process.env.REACT_APP_CLOSING_URL, "_self");
       }
       else{
       AccountDiscoveryHeader.sid=Storage.sessionid;
        // console.log(Storage);
        const AllFipTypes=GetFipTypeForABank(Storage?.selectedbank?.fi_type)
        // console.log(AllFipTypes)

       const message={
        header:AccountDiscoveryHeader,
        payload:{
            ver: "1.1.2",
            timestamp: new Date().toISOString(),
            txnid: uuidv4(),
            Customer: {
            id: Storage?.userid,
            Identifiers: [
            {
            category: "STRONG",
            type: "MOBILE",
            value: Storage?.mobilenumber
            }
            ]
            },
            FIPDetails: {
            fipId: Storage?.selectedbank?.fip_id,
            fipName: Storage?.selectedbank?.fip_name
            },
            FITypes: AllFipTypes
        }
       };


       Socketconnnection.onclose=()=>{
        toast.error("Your session is expired. Please try again");
        localStorage.removeItem('insession');
        setTimeout(()=>{
          localStorage.clear();
          window.open(process.env.REACT_APP_CLOSING_URL, "_self");
        },1000)
       }

       Socketconnnection.send(JSON.stringify(message));


       Socketconnnection.onmessage = (event) => {
        const receivedMessage = JSON.parse(event.data);
       
        // SetDiscoveredAccountDetail(receivedMessage.payload);
        // SelectBankinfo(receivedMessage.payload.DiscoveredAccounts);
        // console.log("messages ",receivedMessage);
        if(receivedMessage.payload?.status=="RECORD-NOT-FOUND")
        {
            toast.error('NO LINKED ACCOUNT NUMBER FOUND');
            SetPendingRequest(false);
            // window.history.back();
            navigate('/selectbank');
        }
        else if(receivedMessage.payload?.status=='FAILURE')
        {
          
            if(nooftimeapicalled>2)
            {
toast.error('Error Connecting With the bank');
            SetPendingRequest(false);
            // window.history.back();
            navigate('/selectbank');
            }
            else{
              handleAccountDiscovery(AllLinkedAccounts,nooftimeapicalled+1);
            }
        }
        else{
        const data=HandleNotLinkedAccountNumbers(receivedMessage?.payload?.DiscoveredAccounts,AllLinkedAccounts,Storage?.selectedbank?.fip_id,Storage?.selectedbank?.fip_name)
        SelectBankinfo(data);
        // console.log("linked dskjb sdkjb  ",data);
        // SelectBankinfo(data);
        if(data.length==0)
        {
           navigate('/confirmconsent');
        }
        
        SetPendingRequest(false);
        HandleUserAccountDiscoverySaved(receivedMessage);
      };
    }
    }

    }
   
    const HandleUserAccountDiscoverySaved=(receivedMessage)=>{

        const message={
            fipId: Storage?.selectedbank?.fip_id,
            userId: Storage?.userid,
            data:receivedMessage
        }
AccountDiscoveryApi(message).then((response)=>{
if(response.status==200)
{

}
}).catch((error)=>{

  if(error?.response?.status==401)
    {
    toast.error("Your session is expired. Please try again");

    setTimeout(()=>{
      localStorage.clear();
           window.open(process.env.REACT_APP_CLOSING_URL, "_self");

    },1000)
  }else{
    Storage.internalservererror=true;
    SetStorage(Storage);
    navigate('/finalresult');
  }
})

    }

   
    const HandleAccountLinking=()=>{

   const Socketconnnection=Storage.Socketconnnection;
   if(!Socketconnnection)
   {

    localStorage.clear();
    window.open(process.env.REACT_APP_CLOSING_URL, "_self");

   }
   else{

   AccountLinkingHeader.sid=Storage.sessionid;

   const message={
    header:AccountLinkingHeader,
    payload:{
        ver: "1.1.2",
        timestamp: new Date().toISOString(),
        txnid: uuidv4(),
        FIPDetails: {
        fipId: Storage?.selectedbank?.fip_id,
        fipName: Storage?.selectedbank?.fip_name
        },
        Customer: {
            id: Storage?.userid,
            Accounts: CheckedData
            }
    }
   };
  //  console.log(message);

   Socketconnnection.onclose=()=>{
    toast.error("Your session is expired. Please try again");
    localStorage.removeItem('insession');
    setTimeout(()=>{
      localStorage.clear();
      window.open(process.env.REACT_APP_CLOSING_URL, "_self");
    },1000)
   }

   Socketconnnection.send(JSON.stringify(message));


Socketconnnection.onmessage = (event) => {
  const receivedMessage = JSON.parse(event.data);
  SetAccountLinkResponse(receivedMessage);
  Storage.AccountLinkingReferNumber=receivedMessage?.payload?.RefNumber;
  SetStorage(Storage);
  // console.log(receivedMessage);
  
  };
   }
    }

const handleClick=(e)=>{
    mixpanel.track("Interacted_BS_Link_Account", {
        "Clicked on": "Verify",
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
    e.preventDefault();
    Setshow(1-show);
            HandleAccountLinking();

}

const handleChange=(e)=>{
 const {value,checked}=e.target;
//  console.log(Bankinfo[value]);
 if(checked)
 {
  SetCheckedData([...CheckedData,Bankinfo[value]]);
 }
 else{
  SetCheckedData(CheckedData.filter((e)=>e!=Bankinfo[value]));
 }
    
}
  return (
<div className='linkaccount' >
{Pendingrequest?<Loader/>:<></>}
<div className='content'>
<p>We found below accounts linked to your mobile.
OTP will be sent by bank for verification</p>

<div className='bank_account'>

{AccountLinkInfo?.map((val,key)=>{
    return(
        <div className='bank'>
            <img src={Storage?.selectedbank?.entity_icon_uri}></img>
            <div className='information'>
             <p className='name'>{Storage?.selectedbank?.fip_name} </p>
             <p className='account'>{GetStringLastvalues(val?.maskedAccNumber)}</p>
             <p className='type'>{val?.accType}</p>
            </div>
            <input type='checkbox' checked={true} className='checkedinput' ></input>
        </div>
            )
})}


{Bankinfo?.map((val,key)=>{
    return(
<div className='bank'>
    <img src={Storage?.selectedbank?.entity_icon_uri}></img>
    <div className='information'>
    <p className='name'>{Storage?.selectedbank?.fip_name}</p>
     <p className='account'>{GetStringLastvalues(val?.maskedAccNumber)}</p>
     <p className='type'>{val?.accType}</p>
    </div>
    <input type='checkbox' value={key} onChange={handleChange}  ></input>
</div>
    )
})}

{/* <div className='bank'>
    <img src={sbi}></img>
    <div className='information'>
    <p className='name'>State Bank of India State Bank of India</p>
     <p className='account'>xxxx876</p>
     <p className='type'>sadkjjbd</p>
    </div>
    <input type='checkbox' value={1} onChange={handleChange}  ></input>
</div> */}

</div>
</div>
{AccountLinkInfo?.length>0?<p className='go_to_linked_accounts' onClick={(e)=>{e.preventDefault();navigate('/confirmconsent')}}>Go to linked accounts</p>:<></>}
<div className='submitbtn'>
<button onClick={handleClick} disabled={(CheckedData.length==0)}>Verify</button>
</div>

{show && <Otp HandleAccountLinking={HandleAccountLinking} Setshow={Setshow}/>}
<Footer/>
</div>

  )
}
